export default {
      id: "snapchat-usage",
      viewBox: "0 0 512 512",
      url: "../../assets/" + "sprite.svg#snapchat-usage",
      toString: function () {
        return this.url;
      }
    }